import { connect } from 'react-redux';
import { withRouter } from '../../../../../../shared/frontend/libs/router/router-helpers';
import { TApplicationState } from '../../libs/store';
import DesktopSiteNavMenu from '../presentational/desktopSiteNavMenu';
import { Media } from '../../../../../../shared/frontend/components/presentational/media';

type TPropsFromState = {
  authenticated: boolean;
  name: string;
};

type TPropsThatDispatch = {};

type TOwnProps = any;

type TAuthBarProps = TPropsFromState & TPropsThatDispatch & TOwnProps;

/**
 * MainNavBarBase
 */
const MainNavBarBase = (props: TAuthBarProps) => {
  return (
    <>
      <Media greaterThanOrEqual="lg">
        <DesktopSiteNavMenu match={props.match} />
      </Media>
    </>
  );
};

// take state from store and convert into props
function mapStateToProps(state: TApplicationState): TPropsFromState {
  return {
    ...state.auth,
    streamers: state.siteConfig.streamers || {},
    streamingGuilds: state.siteConfig.streamingGuilds || {},
    siteMeta: state.siteMeta,
    siteConfig: state.siteConfig,
    currentFeatures: state.currentFeatures
  };
}

export default connect<TPropsFromState, TPropsThatDispatch, TOwnProps>(mapStateToProps)(
  withRouter(MainNavBarBase as any) as any
);
